import React, { FC } from 'react';
import cls from 'classnames';

import { CheckSelect } from '../../index';
import { CheckSelectItemProps } from './CheckSelectItem.types';

const CheckSelectItem: FC<CheckSelectItemProps> = (props) => {
	const { className, children, ...rest } = props;
	return (
		<div className={cls('sds-check-select-item', className)}>
			<CheckSelect {...rest}>
				<p>{children}</p>
			</CheckSelect>
		</div>
	);
};

CheckSelectItem.displayName = 'CheckSelectItem';

export default CheckSelectItem;
